module.exports = __webpack_public_path__ + "img/dsTyBgeQ.21a29fa9.svg";